export default {
  competencies: [],
  competency: undefined,
};
